"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("../Typography"));

var _Switch2 = _interopRequireDefault(require("./Switch.css"));

var Switch =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Switch, _React$PureComponent);

  function Switch() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Switch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Switch)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (_, value) {
      var onChange = _this.props.onChange;
      onChange(value);
    });
    return _this;
  }

  (0, _createClass2.default)(Switch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          classes = _this$props.classes,
          labelValue = _this$props.labelValue,
          labelPlacement = _this$props.labelPlacement,
          color = _this$props.color,
          disabled = _this$props.disabled;
      var switchComponent = React.createElement(_Switch.default, {
        classes: classes,
        checked: checked,
        color: color,
        disabled: disabled,
        onChange: this.handleChange
      });
      return typeof labelValue === 'string' && labelValue.trim().length > 0 ? React.createElement(_FormControlLabel.default, {
        control: switchComponent,
        label: React.createElement(_Typography.default, {
          variant: "subtitle2"
        }, labelValue),
        labelPlacement: labelPlacement
      }) : switchComponent;
    }
  }]);
  return Switch;
}(React.PureComponent);

Switch.defaultProps = {
  classes: {},
  checked: false,
  labelValue: '',
  labelPlacement: 'end',
  color: 'primary',
  disabled: false,
  onChange: function onChange() {}
};
Switch.propType = {
  /**
   * classes: Style object
   */
  classes: PropTypes.object,

  /**
   * checked: Is the Switch active
   */
  checked: PropTypes.boolean,

  /**
   * labelValue:  The text that will be displayed in the label.
   */
  labelValue: PropTypes.string,

  /**
   * labelPlacement: The position of the label.
   */
  labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom']),

  /**
   * color: The color of the switch.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),

  /**
   * If true, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Callback fired when the state is changed.
   */
  onChange: PropTypes.func
};

var _default = (0, _styles.withStyles)(_Switch2.default)(Switch);

exports.default = _default;